// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "css/core.main.5742a5e51977a79e1094.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + ({"3317":"dtrader-header","5283":"url-unavailable-modal"}[chunkId] || chunkId) + "." + {"2015":"94938ecbc423b6640bca","3317":"14e649c107df631e7d59","5283":"2b9856a9b344346bd886","6332":"d5f79087416b5f52d1ab"}[chunkId] + ".css";
};